import type { SimpleButtonProps, ButtonProps } from 'components/common/buttons/SimpleButton/types';
import type { ReactFCC } from 'types/react';

import { PURPLE_60, ORANGE } from 'ui-kit/GlobalStyle/colors';

import { StyledSimpleButton } from './styles';

export const SimpleButton: ReactFCC<SimpleButtonProps> = ({ styleType, disabled, children, ...props }) => (
    <StyledSimpleButton {...props} styleType={styleType} disabled={disabled}>
        {children}
    </StyledSimpleButton>
);

export const SupportButton: ReactFCC<ButtonProps> = props => (
    <SimpleButton
        {...props}
        backgroundColor="white"
        styleType="support"
        color={PURPLE_60}
        fontSize="16px"
        height="48px"
    />
);

export const SupportButtonSecondary: ReactFCC<ButtonProps> = props => (
    <SimpleButton {...props} backgroundColor="white" styleType="support" fontSize="16px" color={ORANGE} height="48px" />
);
